import { useRecoilState, useSetRecoilState } from 'recoil';

import { dialogsStackAtom, RemoteDialogInfo } from './internal.hooks';

export function useOpenDialog() {
  const setDialogsStack = useSetRecoilState(dialogsStackAtom);

  return (
    dialogId: string,
    dialogParams?: unknown,
    onClose?: (answer: unknown) => void
  ) => {
    const instanceId = createId();

    const info: RemoteDialogInfo = {
      dialogId,
      dialogParams,
      instanceId,
      onClose,
    };

    setDialogsStack((currValue) => {
      const newValue = [...currValue];
      newValue.push(info);
      return newValue;
    });

    return instanceId;
  };
}

export function useCloseDialog() {
  const [stack, setStack] = useRecoilState(dialogsStackAtom);

  return (answer?: unknown) => {
    const newStack = [...stack];

    const info = newStack.pop();
    if (!info) {
      // Nothing in the stack
      return;
    }
    if (info.onClose) {
      info.onClose(answer);
    }
    setStack(newStack);
  };
}

function createId() {
  return `msg_${performance.now()}`.replace('.', '_');
}
